/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { type ReactElement } from 'react';
import type { PageWithComponentData } from '@/lib/page-designer/page-loader.server';
import CheckoutFooter from './checkout-footer';
import MainFooter from './main-footer';

interface FooterProps {
    variant?: 'full' | 'checkout';
    paymentBadgesPage?: Promise<PageWithComponentData | null>;
    slotFooterColumn?: Promise<PageWithComponentData | null>;
    slotFooterAccount?: Promise<PageWithComponentData | null>;
    slotFooterSupport?: Promise<PageWithComponentData | null>;
    slotFooterAbout?: Promise<PageWithComponentData | null>;
    slotFooterContact?: Promise<PageWithComponentData | null>;
    footerSlotsAny?: Promise<boolean>;
    slotFooterCopy?: Promise<PageWithComponentData | null>;
}

export default function Footer({
    variant = 'full',
    paymentBadgesPage,
    slotFooterColumn,
    slotFooterAccount,
    slotFooterSupport,
    slotFooterAbout,
    slotFooterContact,
    footerSlotsAny,
    slotFooterCopy,
}: FooterProps): ReactElement {
    return variant === 'checkout' ? (
        <CheckoutFooter />
    ) : (
        <MainFooter
            paymentBadgesPage={paymentBadgesPage}
            slotFooterColumn={slotFooterColumn}
            slotFooterAccount={slotFooterAccount}
            slotFooterSupport={slotFooterSupport}
            slotFooterAbout={slotFooterAbout}
            slotFooterContact={slotFooterContact}
            footerSlotsAny={footerSlotsAny}
            slotFooterCopy={slotFooterCopy}
        />
    );
}
